<template>
  <app-layout>
    <div>
      <CircleProgress />
      <form @submit.prevent="submit">
        <slot></slot>

        <button
          type="submit"
          class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline relative w-full flex-grow md:flex-1 m-1 mt-8"
        >
          {{ $t('see the results') }}
        </button>
      </form>
    </div>
  </app-layout>
</template>


<script>
import CircleProgress from "@/Components/CircleProgress";
import AppLayout from "@/Layouts/AppLayout";

export default {
  components: {
    CircleProgress,
    AppLayout,
  },
  props: ["users"],
  data() {
    return {
      sending: false,
      form: {
        cliente: null,
        score_1: null,
        score_2: null,
        score_3: null,
        score_4: null,
        score_5: null,
        score_6: null,
        score_7: null,
        score_8: null,
        score_9: null,
        score_10: null,
        score_11: null,
        score_12: null,
        score_13: null,
        score_14: null,
        score_15: null,
        score_16: null,
        score_17: null,
        score_18: null,
      },
    };
  },
  methods: {
    submit() {
      this.$inertia.post(this.route("surveys.store"), this.form, {
        onStart: () => (this.sending = true),
        onFinish: () => (this.sending = false),
      });
    },
  },
};
</script>